<template>
	<svg
		viewBox="0 0 30 31"
	>
		<path
			d="M28.9291 15.3944C28.8591 15.129 28.738 14.8802 28.5727 14.6622C28.4074 14.4442 28.2013 14.2613 27.966 14.1238C27.7307 13.9864 27.4708 13.8972 27.2014 13.8614C26.9319 13.8255 26.6581 13.8437 26.3956 13.9149L19.0566 15.9027L9.52756 6.9248L6.86189 7.64988L12.5787 17.6608L5.71532 19.5167L3.00288 17.361L1 17.9052L3.51247 22.3046L4.5639 24.1556L6.77965 23.556L14.1187 21.5681L20.1193 19.9387L27.4632 17.9558C27.7261 17.8852 27.9727 17.7629 28.1888 17.5959C28.4048 17.4289 28.5861 17.2204 28.7223 16.9825C28.8585 16.7445 28.9469 16.4818 28.9823 16.2092C29.0178 15.9367 28.9997 15.6598 28.9291 15.3944Z"
		/>
	</svg>
</template>
